module.exports = __webpack_public_path__ + "static/img/会计凭证.1b8efd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronic/会计凭证.png
// module id = fbmq
// module chunks = 2